import React, { Component } from "react";
import {
  UploadContainer,
  SectionToolbar,
  ToolbarItem
} from "@sc/Section.styled";
import {
  SectionHeading,
  SectionNameEditable,
  UploadHeaderContainer
} from "@c/activity-view/activity-creator/activity-info/ActivityInfo.styled";
import { SubHeading } from "static/styled/custom.styled";
import store from "store";
import actions from "store/story/actions";
import swal from "sweetalert2";
import VideoSection from "@c/activity-view/activity-creator/video-section/VideoSection";
import TextSection from "@c/activity-view/activity-creator/text-section/TextSection";
import ImageSection from "@c/activity-view/activity-creator/image-section/ImageSection";
import AudioSection from "@c/activity-view/activity-creator/audio-section/AudioSection";
import YoutubeSection from "@c/activity-view/activity-creator/youtube-section/YoutubeSection";
import FileSection from "@c/activity-view/activity-creator/file-section/FileSection";
import { module as story } from "store/story";
import { UploadButton } from "./Section.styled";

import { connectStore } from "redux-box";
import { RemoveSection } from "@c/activity-view/activity-creator/activity-info/ActivityInfo.styled";
import { module as onboard } from "@st/onboard";
import Permission from "@s/permission";

class Section extends Component {
  constructor(props) {
    super();
    this.state = {
      enableEdit: false,
      name: ""
    };
  }

  componentDidMount() {
    this.setState({
      name: this.props.section.name
    });
  }

  getSectionContent = () => {
    let dataType = this.props.section.content_type;
    if (dataType === "video")
      return <VideoSection media={this.props.section.media} dataType={dataType}/>;
    else if (dataType === "text")
      return <TextSection description={this.props.section.description} dataType={dataType}/>;
    else if (dataType === "image")
      return <ImageSection media={this.props.section.media} dataType={dataType}/>;
    else if (dataType === "audio")
      return <AudioSection media={this.props.section.media} dataType={dataType}/>;
    else if (dataType === "youtube")
      return <YoutubeSection media={this.props.section.media} dataType={dataType}/>;
    else if (dataType === "pdf" || dataType === "epub")
      return (
        <FileSection media={this.props.section.media} dataType={dataType} />
      );

    // return <VideoSection media={this.props.data.media} />
  };

  handleSectionEditable = evt => {
    const { section } = this.props;
    if (evt.keyCode === 13) {
      this.setState({ enableEdit: false });
      store.dispatch(actions.setActiveStorySection(section));
      store.dispatch(
        actions.requestUpdateStorySection({
          name: this.state.name,
          content_type: this.props.section.content_type
        })
      );
    }
  };

  handleSectionNameChange = id => e => {
    this.setState({
      name: e.target.value
    });
  };

  handleSectionRemoval = evt => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        store.dispatch(actions.removeStorySection());
      }
    });
  };

  showSubContainerWith = type => () => {
    this.props.handleShowSubContainer(type);
  };

  enableEdit = () => {
    this.setState({
      enableEdit: !this.state.enableEdit
    });
  };

  startUpdate = () => {
    let dataType = this.props.section.content_type;
    store.dispatch(
      actions.startUpdatingStorySection(dataType, this.props.section)
    );
  };

  showSubContainer = () => {
    store.dispatch(actions.setActiveStorySection(this.props.section));
    let type = this.props.section.content_type;
    this.props.handleShowSubContainer(type);
  };

  deleteSection = () => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        store.dispatch(actions.deleteStorySection(this.props.section));
        this.props.story.setStoryEditorType("");
      }
    });
  };

  startTextSection = () => {
    this.props.story.setStoryEditorType("text");
    this.props.story.startCreatingStorySection("text", this.props.section);
    this.props.story.setStoryActionType("update");
  };
  startMediaSection = () => {
    this.props.story.setStoryEditorType("media");
    this.props.story.startCreatingStorySection("media", this.props.section);
    this.props.story.setStoryActionType("update");
  };

  removeSection = () => {
    store.dispatch(actions.deleteStorySection(this.props.section));
    this.props.story.setStoryEditorType("");
  };

  render() {
    let section = this.props.section;
    const {permission} = this.props.onboard;
    return (
      <UploadContainer>
        <UploadHeaderContainer>
          <UploadHeaderContainer>
            {this.state.enableEdit ||
            (this.props.section && this.props.section.name === "") ? (
              <SectionHeading
                width={"45%"}
                placeholder="Enter Section Name"
                type="text"
                autoFocus
                value={this.state.name}
                onChange={this.handleSectionNameChange(section.id)}
                onKeyDown={this.handleSectionEditable}
              />
            ) : (
              <SectionNameEditable>
                <SubHeading
                  primary
                  style={{ minWidth: "160px" }}
                  width={(section.name.length + 1) * 10 + "px"}
                >
                  {section.name}
                </SubHeading>
                {Permission.getPermission(permission, "change_story")?
                <img
                  src={require("static/img/editicon.png")}
                  alt="edit icon"
                  className="image-fluid"
                  onClick={this.enableEdit}
                />:null}
              </SectionNameEditable>
            )}
            {Permission.getPermission(permission, "change_story")?
            this.props.section.media.length > 0 ||
            this.props.section.description.length > 0 ? (
              <SectionToolbar>
                <ToolbarItem primary onClick={this.startUpdate}>
                  <div className="icon-container">
                    <i className="fa fa-pencil" />
                  </div>
                </ToolbarItem>
                <ToolbarItem onClick={this.deleteSection}>
                  <div className="icon-container">
                    <i className="fa fa-trash" />
                  </div>
                </ToolbarItem>
              </SectionToolbar>
            ) : (
              <RemoveSection onClick={this.removeSection}>
                Remove Section
              </RemoveSection>
            ):null}
          </UploadHeaderContainer>
        </UploadHeaderContainer>
        {this.props.section.media.length > 0 ||
        this.props.section.description.length > 0 ? (
          this.getSectionContent()
        ) : (
          <div>
            <UploadButton onClick={this.startTextSection}>
              <img
                className="img-fluid"
                src={require("static/img/edit.png")}
                alt="add notes"
              />{" "}
              Add notes
            </UploadButton>
            <UploadButton onClick={this.startMediaSection}>
              <img
                className="img-fluid"
                src={require("static/img/link.png")}
                alt="add media"
              />{" "}
              Add Media
            </UploadButton>
          </div>
        )}
      </UploadContainer>
    );
  }
}
export default connectStore({
  story,onboard
})(Section)